import React, { useRef } from 'react'
import type { ReactNode } from 'react'

import { welcomeGuidedTour } from '@/constants/welcomeGuidedTour'
import { MenuItem } from '@components/atoms'
import {
	Board24Regular,
	Book24Regular,
	BookGlobe24Regular,
	Bookmark24Regular,
	BookSearch24Regular,
	Notebook24Regular,
	PersonFeedback24Regular,
	/* 	People24Regular,
	Premium24Regular, */
	Wand24Regular,
	TasksApp24Regular,
	Trophy24Regular,
} from '@fluentui/react-icons'
import { useIsMobile } from '@hooks'
import { headerCreators } from '@store/ducks/header'
import { useAppDispatch, useAppSelector } from '@store/hooks'

import BasicGuidedTour, { useBasicGuidedTour } from '../BasicGuidedTour'
import ModalCampaign from '../ModalCampaign'
import { sideMenuStyles } from './styles'

const { SideMenu: SideMenuStitches, OverlaySideMenu } = sideMenuStyles

type menuOptionsProps = {
	id: string
	route: string
	name: string
	icon: ReactNode
	items?: Array<{
		route: string
		name: string
		icon: ReactNode
		tourId?: string
	}>
	tourId?: string
}

const menuOptions: menuOptionsProps[] = [
	{
		id: '1',
		route: '/',
		name: 'Dashboard',
		icon: <Board24Regular />,
		tourId: 'dashboard',
	},
	{
		id: '2',
		route: '/vade-mecum-de-questoes',
		name: 'Vade Mecum de Questões',
		icon: <BookSearch24Regular />,
		items: [
			{
				route: '/vade-mecum-de-questoes',
				name: 'Acessar questões',
				icon: <Book24Regular />,
				tourId: 'vade-mecum-de-questoes',
			},
			{
				route: '/cadernos',
				name: 'Cadernos',
				icon: <Book24Regular />,
				tourId: 'cadernos',
			},
			{
				route: '/simulados',
				name: 'Simulados',
				icon: <TasksApp24Regular />,
				tourId: 'simulados',
			},
			{
				route: '/disciplinas',
				name: 'Disciplinas',
				icon: <Notebook24Regular />,
				tourId: 'disciplinas',
			},
			{
				route: '/rankings',
				name: 'Rankings',
				icon: <Trophy24Regular />,
				tourId: 'rankings',
			},
			{
				route: '/filtros-salvos',
				name: 'Filtros salvos',
				icon: <Bookmark24Regular />,
				tourId: 'filtros-salvos',
			},
		],
	},
	{
		id: '8',
		route: '/cursos',
		name: 'Cursos',
		icon: <BookGlobe24Regular />,
		tourId: 'cursos',
	},
	/* 	{
		id: '9',
		route: '/comunidade',
		name: 'Comunidade',
		icon: <People24Regular />,
	},
	{ id: '10', route: '/planos', name: 'Planos', icon: <Premium24Regular /> }, */
]

const SideMenu = () => {
	const ref = useRef<HTMLDivElement>(null)

	const { header } = useAppSelector((state) => state)
	const dispatch = useAppDispatch()

	const mobile = useIsMobile()

	const { startTour, bind } = useBasicGuidedTour()

	return mobile ? (
		<>
			<BasicGuidedTour bind={bind} steps={welcomeGuidedTour} />
			{JSON.parse(header.value) && (
				<OverlaySideMenu
					open={JSON.parse(header.value)}
					onClick={(event) => {
						if (ref.current === event.target) {
							return dispatch(headerCreators.openSidebar())
						}

						return ''
					}}
					ref={ref}
				>
					<SideMenuStitches isOpened>
						{menuOptions.map(({ id, route, icon, name, items }) => (
							<MenuItem
								key={id}
								to={route}
								icon={icon}
								name={name}
								items={items}
								isOpened={JSON.parse(header.value)}
								onClick={() => {
									dispatch(headerCreators.openSidebar())
								}}
							/>
						))}

						<div style={{ marginTop: '', paddingBottom: '12px' }}>
							<MenuItem
								key='guided-tour'
								to='https://'
								icon={<Wand24Regular />}
								name={<span>Tour explicativo</span>}
								isOpened={JSON.parse(header.value)}
								onClick={startTour}
								className='tour'
								isButton
							/>
						</div>

						<div style={{ marginTop: 'auto', paddingBottom: '12px' }}>
							<MenuItem
								key='survey'
								to='https://forms.gle/n9E7wk2ntqsdfghe9'
								icon={<PersonFeedback24Regular color='#6BBBDC' />}
								name={<span style={{ color: '#6BBBDC' }}>Dê sua opinião!</span>}
								isOpened={JSON.parse(header.value)}
								externalLink
							/>
						</div>
						<ModalCampaign />
					</SideMenuStitches>
				</OverlaySideMenu>
			)}
		</>
	) : (
		<>
			<BasicGuidedTour bind={bind} steps={welcomeGuidedTour} />

			<SideMenuStitches isOpened={JSON.parse(header.value)}>
				{menuOptions.map(({ id, route, icon, name, items, tourId }) => (
					<MenuItem
						key={id}
						to={route}
						icon={icon}
						name={name}
						items={items}
						isOpened={JSON.parse(header.value)}
						className={tourId}
					/>
				))}
				<div style={{ marginTop: '', paddingBottom: '12px' }}>
					<MenuItem
						key='guided-tour'
						to='https://'
						icon={<Wand24Regular />}
						name={<span>Tour explicativo</span>}
						isOpened={JSON.parse(header.value)}
						onClick={startTour}
						className='tour'
						isButton
					/>
				</div>
				<div style={{ marginTop: 'auto', paddingBottom: '12px' }}>
					<MenuItem
						key='survey'
						to='https://forms.gle/n9E7wk2ntqsdfghe9'
						icon={<PersonFeedback24Regular color='#6BBBDC' />}
						name={<span style={{ color: '#6BbBDC' }}>Dê sua opinião!</span>}
						isOpened={JSON.parse(header.value)}
						externalLink
					/>
				</div>
				<ModalCampaign />
			</SideMenuStitches>
		</>
	)
}

export { SideMenu }
